const BASE_URL = process.env.NEXT_PUBLIC_APIGEE_URL;
const BASE_HEADER = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
};
export const ADDITIONAL_HEADER_FOR_GET_SCENARIO = {
  Accept: 'application/vnp.kms-api.v2+json',
};

export function getScenarioQueryParams(locale: string) {
  return {
    v: 2,
    plainText: false,
    processLinks: true,
    language: locale,
  };
}

//TODO: Will removed after all the API's migrated to APIGEE
export async function getToken() {
  return 'undefined';
}

export async function fetchService(
  path: string,
  method: string,
  // biome-ignore lint/style/useDefaultParameterLast: <this has been called in multiple>
  queryParams = {},
  header: object | null,
  body: FormData | object | null,
) {
  const url = new URL(`${BASE_URL}${path}`);
  if (Object.keys(queryParams).length > 0) {
    for (const key of Object.keys(queryParams)) {
      url.searchParams.append(
        key,
        queryParams[key as keyof typeof queryParams],
      );
    }
  }
  const config = {
    method,
    ...(header
      ? {
          headers: {
            ...BASE_HEADER,
            ...header,
          },
        }
      : {}),
    ...(body ? {body: JSON.stringify(body)} : {}),
  };
  const request = new Request(url, config);
  try {
    const response = await fetch(request);
    if (response?.ok) {
      const json = await response.json();
      return json;
    }
    //handle fallback case for 404 page
    return {
      status: response?.status,
      ok: response?.ok,
    };
  } catch (error) {
    throw new Error(`Failed to fetch KMS service - ${error}`);
  }
}
